/**
 * Created by slava on 24.03.17.
 */

const ForceView = cc.Node.extend({
    ctor: function (element, force, options) {
        this._super();

        this.focus = cleverapps.focusManager.focus;
        this.focusState = cleverapps.focusManager.getState();

        this.forceConfig = force;
        this.options = options || {};
        this.force = force;
        this.element = element;

        this.actives = this.options.actives || [];
        if (element !== ForceView.NO_ELEMENT) {
            this.actives.push(element);
        }

        this.highlights = (this.options.highlights || []);
        if (this.options.highlightActives !== false) {
            this.highlights = this.highlights.concat(this.actives);
        }

        cleverapps.Scenes.GetRunningScene().addChild(this);

        this.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 9);
        this.setAnchorPoint(0.5, 0.5);
        this.onResize();

        if (force.controls) {
            cleverapps.focusManager.showControlsWhileFocused(force.controls, true);
        }

        this.id = force.id;
        this.saveInLocation = force.saveInLocation;
        this.text = typeof (force.text) === "function" ? force.text(force, element) : Messages.get(force.text);

        console.log("display force", this.text);
        TextHighlightValidation.check(this.text);

        if (this.options.onSkip && cleverapps.config.debugMode) {
            this.createSkipButton();
        }

        cleverapps.focusManager.setEventNodes(this.actives.slice());

        cleverapps.toolbar.freezeUpdates();

        if (element !== ForceView.NO_ELEMENT && force.finger !== false) {
            this.createFinger();
        }
        if (element !== ForceView.NO_ELEMENT && force.pointer) {
            this.createPointer();
        }
        this.upNodesForForce();

        if ((element === ForceView.NO_ELEMENT && this.forceConfig.closeByTouchInShadow !== false) || this.forceConfig.closeByTouchInShadow) {
            const delay = this.forceConfig.closeByTouchInShadow && this.forceConfig.closeByTouchInShadow.delay || 0;
            cleverapps.timeouts.setTimeout(this.createListener(() => this.addCloseByTouchInShadow()), delay);
        }

        if (element !== ForceView.NO_ELEMENT && !this.forceConfig.disableFallbackTimeout) {
            this.watchElementInterval = cleverapps.timeouts.setInterval(() => {
                // console.log('watchElementInterval', this.element.parent)
                if (!this.element.parent || !this.element.visible || this.forceConfig.timeout) {
                    if (cleverapps.forces.isRunningForce()) {
                        cleverapps.forces.closeRunningForce();
                    } else {
                        this.close();
                        cleverapps.forces.clearForce(this);
                    }
                }
            }, this.forceConfig.timeout || 5000);
        }

        if (this.text) {
            this.createDialogue();
        }

        if (this.forceConfig.shadow !== false) {
            cleverapps.shadow.show(this.forceConfig.shadow && this.forceConfig.shadow.delay !== undefined ? this.forceConfig.shadow.delay : true);
            cleverapps.shadow.moveUp();
        }

        cleverapps.focusManager.on("changeFocus", () => this.onChangeFocus(), this);
    },

    onChangeFocus: function () {
        // PointerHandler raises a stacked "dragging" focus for the length of every drag it claims, so
        // a force over something the player drags saw the focus change twice per gesture and blinked
        // its message off and on again. A drag is not another screen taking over, it is the player
        // doing what the force asked, so a force can ask to sit through it. Doing nothing rather than
        // taking the else branch matters: showing the dialogue again also calls setEventNodes, which
        // mid-drag swaps what receives touches out from under the gesture and kills it.
        if (this.forceConfig.persistent && cleverapps.focusManager.focus === "dragging") {
            return;
        }

        if (cleverapps.focusManager.focus !== this.focus) {
            this.dialogue && this.dialogue.hide();
            this.clickArea && this.clickArea.setVisible(false);
            this.stopFinger();
        } else {
            cleverapps.focusManager.setEventNodes(this.actives.slice());
            this.dialogue && this.dialogue.showUp();
            this.clickArea && this.clickArea.setVisible(true);
            this.resumeFinger();
        }
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        this.setContentSize(sceneSize.width, sceneSize.height);
        this.setAlignment(sceneSize.width / 2, sceneSize.height / 2);

        if (this.clickArea) {
            this.clickArea.setContentSize(this.getContentSize());
        }

        if (this.tapToContinue) {
            this.tapToContinue.onResize();
            this.tapToContinue.setAlignment(cleverapps.styles.ForceView.tapToContinue);
        }
    },

    onAfterResize: function () {
        if (cleverapps.focusManager.focus !== this.focus) {
            return;
        }

        if (this.dialogue) {
            this.createDialogue();
        }

        if (this.finger) {
            FingerView.remove(this.finger);
            this.createFinger();
        }

        if (this.tapToContinue) {
            this.updateTapToContinue();
        }
    },

    close: function () {
        if (this.forceConfig.shadow !== false) {
            cleverapps.shadow.moveDown();

            if (!cleverapps.focusManager.currentWindow()) {
                cleverapps.shadow.hide(true);
            }
        }

        if (this.watchElementInterval) {
            cleverapps.timeouts.clearInterval(this.watchElementInterval);
        }

        this.backNodesFromForce();

        FingerView.remove(this.finger);
        PointerView.remove(this.pointer);
        this.pointer = undefined;
        this.finger = undefined;

        cleverapps.toolbar.unfreezeUpdates();

        this.focusState.eventNodes.length = 0;

        this.removeFromParent();
    },

    upNodesForForce: function () {
        if (this.forceConfig.shadow !== false) {
            this.highlights.forEach((node) => {
                node && node._setGlobalZOrder(true);
            }, this);
        }
    },

    backNodesFromForce: function () {
        if (this.forceConfig.shadow !== false) {
            this.highlights.forEach((node) => {
                node && node._setGlobalZOrder(false);
            }, this);
        }
    },

    listRects: function () {
        const rects = [];
        if (this.options.importantNodes) {
            this.options.importantNodes.forEach((node) => {
                if (node.isRunning()) {
                    rects.push(node.getSceneBoundingBox());
                }
            });
        }

        if (this.pointer) {
            rects.push(this.pointer.getSceneBoundingBox());
        }

        if (this.finger && this.finger.isRunning()) {
            rects.push(this.finger.getOverlapNode().getSceneBoundingBox());
        }

        if (this.options.highlightActives !== false) {
            this.actives.forEach((active) => {
                if (active.isRunning()) {
                    rects.push(active.getSceneBoundingBox());
                }
            });
        }

        return rects;
    },

    createFinger: function () {
        let fingerStyle = this.force.finger || {};
        if (typeof fingerStyle === "function") {
            fingerStyle = fingerStyle();
        }
        if (fingerStyle.mobile && cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            fingerStyle = fingerStyle.mobile;
        }

        const fingerDelay = fingerStyle.delay;

        if (fingerStyle.path) {
            this.finger = FingerView.hintDrag(fingerStyle.path, fingerStyle);
        } else if (fingerStyle.swipe) {
            this.finger = FingerView.hintSwipe(fingerStyle.swipe[0], fingerStyle.swipe[1], fingerStyle);
        } else {
            this.finger = FingerView.hintTap(fingerStyle.tap || this.element, {
                delay: fingerDelay,
                repeatDelay: fingerDelay,
                double: fingerStyle.double
            });
        }
    },

    createSkipButton: function () {
        const skipButton = this.skipButton = new cc.Sprite(bundles.dialogues.frames.skip_button_png);
        skipButton.setAlignment(cleverapps.styles.ForceView.skipButton);
        this.addChild(skipButton, 2);

        cleverapps.UI.applyHover(skipButton);
        cleverapps.UI.onClick(skipButton, this.options.onSkip);

        this.actives.push(skipButton);
    },

    createPointer: function () {
        this.pointer = PointerView.create({
            target: this.element,
            direction: this.options.pointerDirection
        });
        this.highlights.push(this.pointer);
    },

    createDialogue: function () {
        if (this.dialogue) {
            this.dialogue.removeFromParent();
        }

        this.dialogue = new MinimalDialogue({
            text: this.text,
            person: this.force.person,
            targetRect: this.element && this.element !== ForceView.NO_ELEMENT && this.element.getSceneBoundingBox(),
            rects: this.listRects(),
            position: typeof (this.force.position) === "function" ? this.force.position() : this.force.position,
            gravitate: this.force.gravitate,
            delay: this.force.minimal && this.force.minimal.delay,
            // persistent: the text stays up for the life of the force - through the player's drag
            // and past MinimalDialogue's give-up timeout on a spot it could not fit - so a tutorial
            // step's instruction is readable until the step is done.
            persistent: this.force.persistent,
            onOk: this.forceConfig.okButton ? this.touchInShadow.bind(this) : undefined
        });
        this.dialogue._globbbb = true;
        this.addChild(this.dialogue);
        this.dialogue.display();
    },

    addCloseByTouchInShadow: function () {
        this.clickArea = new cc.Node();
        this.clickArea.alwaysOn = true;
        this.clickArea.setContentSize(this.getContentSize());
        this.addChild(this.clickArea, -1);

        cleverapps.UI.onClick(this.clickArea, this.touchInShadow.bind(this), {
            interactiveScale: false
        });

        if (this.element === ForceView.NO_ELEMENT && this.forceConfig.tapToContinue !== false && !this.forceConfig.okButton) {
            this.createTapToContinue();
        }
    },

    touchInShadow: function () {
        if (cleverapps.forces.isRunningForce()) {
            cleverapps.forces.closeRunningForce();
        }

        cleverapps.tutorial.trigger("touchInShadow");
    },

    createTapToContinue: function () {
        this.tapToContinue = new TapToContinue({
            text: Messages.get("Window.TapToContinue")
        });
        this.tapToContinue.setAlignment(cleverapps.styles.ForceView.tapToContinue);
        this.addChild(this.tapToContinue);
        this.updateTapToContinue();
    },

    updateTapToContinue: function () {
        const rects = this.listRects().concat(this.highlights.filter((node) => node && node.isRunning()).map((node) => node.getSceneBoundingBox()));
        if (this.dialogue) {
            rects.push(this.dialogue.getSceneBoundingBox());
        }

        const box = this.tapToContinue.getSceneBoundingBox();
        const overlapped = rects.some((rect) => cc.rectIntersectsRect(rect, box));

        if (overlapped) {
            this.tapToContinue.hide(true);
        } else if (!this.tapToContinue.visible) {
            this.tapToContinue.show();
        }
    },

    // Re-points the finger at something else, in place. Raising a new force to move it takes the
    // dialogue, the shadow and the highlights down and puts them back up, which reads as a blink
    // after every move on a step that walks the player through several cells. hintTap rebuilds the
    // finger's own actions and plays them, so nothing else about the force is touched — including
    // the event nodes, which is what made rebuilding mid-gesture kill the drag.
    pointFingerAt: function (target) {
        if (!this.finger) {
            return;
        }

        const fingerStyle = this.force.finger || {};
        this.force.finger = { ...fingerStyle, tap: cleverapps.toArray(target) };

        this.finger.stopped = false;
        this.finger.hintTap(target, this.finger.options || { delay: fingerStyle.delay, repeatDelay: fingerStyle.delay });
    },

    stopFinger: function () {
        if (this.finger) {
            this.finger.stopPlaying();
        }
    },

    resumeFinger: function () {
        if (this.finger) {
            this.finger.resumePlaying();
        }
    },

    hideForceHints: function () {
        if (this.dialogue) {
            this.dialogue.removeFromParent();
            this.dialogue = undefined;
        }

        if (this.tapToContinue) {
            this.tapToContinue.removeFromParent();
            this.tapToContinue = undefined;
        }

        if (this.pointer) {
            PointerView.remove(this.pointer);
            this.pointer = undefined;
        }

        if (this.finger) {
            FingerView.remove(this.finger);
            this.finger = undefined;
        }

        this.focusState.eventNodes.length = 0;
    }
});

ForceView.NO_ELEMENT = "emptyForceElement";

cleverapps.styles.ForceView = {
    skipButton: {
        x: { align: "right", dx: 0 },
        y: { align: "top", dy: -50 }
    },

    tapToContinue: {
        x: { align: "center" },
        y: { align: "bottom", dy: 40 }
    }
};
